export const GET_TRANSACTION_DETAILS = 'GET_TRANSACTION_DETAILS';
export const GET_TRANSACTION_DETAILS_ERROR = 'GET_TRANSACTION_DETAILS_ERROR';
export const GET_TRANSACTION_DETAILS_SUCCESS = 'GET_TRANSACTION_DETAILS_SUCCESS';

export const GET_TRANSACTIONS_FOR_EXTERNAL = 'GET_TRANSACTIONS_FOR_EXTERNAL';
export const GET_TRANSACTIONS_FOR_EXTERNAL_ERROR = 'GET_TRANSACTIONS_FOR_EXTERNAL_ERROR';
export const GET_TRANSACTIONS_FOR_EXTERNAL_SUCCESS = 'GET_TRANSACTIONS_FOR_EXTERNAL_SUCCESS';